<script lang="ts">
	import type { PromotionItem } from '$models/Block/PromotionBlock';
	import PromotionItemComponent from '$components/Block/Promotion/PromotionItem.svelte';
	import SliderWrapper from '$components/UI/Slider/SliderWrapper.svelte';

	interface Props {
		items: PromotionItem[];
		title?: string;
	}

	const { items, title }: Props = $props();
</script>

<div class="promotion">
	<div class="promotion-inner promotion-inner--count-{items.length}">
		<SliderWrapper
			options={{ loop: false, align: 'start', slidesToScroll: 1, inViewThreshold: 1 }}
			nav="arrows"
		>
			{#snippet header()}
				{#if title}
					<div class="block-header block-header--margin-small block-header--align-left">
						<h2 class="block-title">{title}</h2>
					</div>
				{/if}
			{/snippet}

			{#snippet slides(Slide)}
				{#each items as item}
					<Slide>
						<PromotionItemComponent {item} />
					</Slide>
				{/each}
			{/snippet}
		</SliderWrapper>
	</div>
</div>

<style lang="postcss" global>
	.promotion {
		.slider,
		.slider-viewport {
			overflow: visible;
		}

		.slider {
			--slide-size: 90%;

			@media (--xs) {
				--slide-size: 65%;
			}

			@media (--sm) {
				--slide-size: 55%;
			}

			@media (--md) {
				--slide-size: 45%;
			}
		}

		&-inner {
			&--count-2 .slider {
				@media (--md) {
					--slide-size: 50%;
				}
			}

			&--count-3 .slider,
			&--count-4 .slider {
				@media (--lg) {
					--slide-size: 33.3333%;
				}
			}
		}
	}
</style>
